import React, { useEffect, useState } from 'react';
import {
	Button,
	Div,
	List,
	Panel,
	Typography,
} from '@icecreamsocial/components';
import { IcsV1 } from '@icecreamsocial/api-resources';
import { PageWrapper } from '../../../../presentational';
import { SubscriptionOption } from '../components';
import { useQueryString } from '../../../../hooks';

export const SubscriptionOptions = () => {
	const [loading, setLoading] = useState(false);
	const [emailUnsubscribed, setEmailUnsubscribed] = useState(false);
	const [emailError, setEmailError] = useState(null);
	const { query } = useQueryString();
	const campaignId = decodeURIComponent(query?.cid || '');
	const influencerId = decodeURIComponent(query?.iid || '');
	const email = decodeURIComponent(query?.email || '');
	const publicKey = decodeURIComponent(query?.publicKey || '');
	const sms = decodeURIComponent(query?.sms || '');

	const unsubscribe = async () => {
		try {
			setEmailError(null);
			setLoading(true);
			const res = await IcsV1.ClientV1.unsubscribe({
				campaignId,
				email,
				publicKey,
			});
			setEmailUnsubscribed(true);
		} catch (e) {
			setEmailError(
				// @ts-ignore
				"An error has occurred.  Please double check if you clicked 'Unsubscribe' directly from your Ice Cream Social emails"
			);
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

	const resubscribe = async () => {
		try {
			setEmailError(null);
			setLoading(true);
			const res = await IcsV1.ClientV1.resubscribe({
				campaignId,
				email,
				publicKey,
			});
			setEmailUnsubscribed(false);
		} catch (e) {
			setEmailError(
				// @ts-ignore
				"An error has occurred.  Please double check if you clicked 'Unsubscribe' directly from your Ice Cream Social emails"
			);
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

	return (
		<PageWrapper elMaxWidth='901px'>
			<Typography.H1>Communication Preferences</Typography.H1>
			{/* <Typography.P>
				Manage your notifications about this{' '}
				<Typography.Span textDecoration="underline">
					Campaign Name
				</Typography.Span>{' '}
				offer:
			</Typography.P>
			<Panel backgroundColor="ambient">
				<Panel.Body>
					<Typography.H2>Campaign Offer Title</Typography.H2>
					<Typography.P display="block">
						Ad sit ut do nostrud deserunt aute nulla consectetur minim. Dolore
						ea quis velit consequat exercitation anim sit voluptate minim
						laborum duis adipisicing. Cillum minim eiusmod do laborum sit
						commodo.
					</Typography.P>
				</Panel.Body>
			</Panel> */}
			<Typography.P>
				By unsubscribing, you could miss out on important updates, but you can
				re-subscribe anytime you want
			</Typography.P>
			{email && (
				<SubscriptionOption
					heading='Email Notifications'
					label='Your Email Address'
					loading={loading}
					value={email}
					ctaText='Unsubscribe from Emails'
					unsubscribed={emailUnsubscribed}
					onUnsubscribe={unsubscribe}
					onResubsribe={() => undefined}
					error={emailError}
				/>
			)}
			{sms && (
				<SubscriptionOption
					heading='SMS Notifications'
					label='Your Mobile Number'
					value={sms}
					ctaText='Unsubscribe from SMS'
					onUnsubscribe={() => alert('no SMS!')}
					onResubsribe={() => undefined}
				/>
			)}
			{!email && !sms && (
				<Panel backgroundColor='ambient'>
					<Panel.Body padding='xlg'>
						<Typography.P>
							Unsubscribe by clicking the{' '}
							<Typography.Span typoWeight='bold'>Unsubscribe</Typography.Span>{' '}
							link provided at the bottom of one of your Ice Cream Social
							emails.
						</Typography.P>
					</Panel.Body>
				</Panel>
			)}
		</PageWrapper>
	);
};
